var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4V2M16 4V2M12 22C7.993 22 5.99 22 4.745 20.682C3.5 19.364 3.5 17.242 3.5 13C3.5 8.758 3.5 6.636 4.745 5.318C5.99 4 7.993 4 12 4C16.007 4 18.01 4 19.255 5.318C20.5 6.636 20.5 8.758 20.5 13C20.5 17.242 20.5 19.364 19.255 20.682C18.01 22 16.007 22 12 22Z",
    stroke: "#585858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0178 9.49219C14.0178 10.0226 13.8071 10.5313 13.432 10.9064C13.057 11.2815 12.5483 11.4922 12.0178 11.4922C11.4874 11.4922 10.9787 11.2815 10.6036 10.9064C10.2285 10.5313 10.0178 10.0226 10.0178 9.49219C10.0178 8.96175 10.2285 8.45305 10.6036 8.07797C10.9787 7.7029 11.4874 7.49219 12.0178 7.49219C12.5483 7.49219 13.057 7.7029 13.432 8.07797C13.8071 8.45305 14.0178 8.96175 14.0178 9.49219ZM8.06283 16.7152C9.12083 15.0852 10.8018 14.4752 12.0178 14.4762C13.2338 14.4772 14.8658 15.0862 15.9238 16.7162C15.9918 16.8212 16.0108 16.9502 15.9488 17.0602C15.7018 17.4992 14.9328 18.3702 14.3788 18.4292C13.7408 18.4962 12.0718 18.5062 12.0188 18.5062C11.9658 18.5062 10.2468 18.4962 9.60883 18.4292C9.05283 18.3692 8.28483 17.4992 8.03683 17.0592C7.97583 16.9502 7.99483 16.8212 8.06283 16.7152Z",
    stroke: "#585858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactForm);
export default __webpack_public_path__ + "static/media/contact-form.bdc6b2b4a629ef89f0c35ed5e43fff19.svg";
export { ForwardRef as ReactComponent };